<template>
  <div class="metrics-class-filters">
    <metrics-assignments-filter
      :items="assignments"
      :all-label="$t('metrics.allAssignments')"
      :value="selectedAssignments"
      @input="$emit('update:selectedAssignments', $event)"
    />

    <eg-dropdown
      ref="dropdown"
      :text="selectedTimeFilterLabel"
      class="metrics-class-filters__time-filter"
    >
      <eg-b-dropdown-item-button
        v-for="option in timeFilterOptions"
        :key="option.value"
        @click="$emit('update:timeFilter', option.value)"
      >
        {{ option.label }}
      </eg-b-dropdown-item-button>
    </eg-dropdown>
  </div>
</template>

<script>
import MetricsAssignmentsFilter from "../shared/metrics_multi_filter.vue";
import { METRICS_TIME_FILTERS } from "../../demo_data/shared.js";
import dropdownHideOnLeaveMixin from "@/mixins/dropdownHideOnLeaveMixin";

export default {
  name: "MetricsClassFilters",

  components: {
    MetricsAssignmentsFilter,
  },

  mixins: [dropdownHideOnLeaveMixin],

  props: {
    assignments: {
      type: Array,
      default: () => [],
    },
    selectedAssignments: {
      default: null,
    },
    timeFilter: {
      type: String,
      default: METRICS_TIME_FILTERS[0].value,
    },
  },

  computed: {
    timeFilterOptions() {
      return METRICS_TIME_FILTERS.map((o) => ({
        ...o,
        label: this.$t(o.labelKey),
      }));
    },

    selectedTimeFilterLabel() {
      const found = this.timeFilterOptions.find(
        (o) => o.value === this.timeFilter
      );
      return found ? found.label : "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../shared/metrics_card";

.metrics-class-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 0 24px;

  &__time-filter {
    min-width: 130px;
    @include metrics-dropdown;
    ::v-deep .btn {
      background: var(--color-surface-neutral-background, #f7f9fa);
    }
  }
}
</style>
